import { WorkflowFormData } from "../types/types";
import { OffHoursFormData } from "../../../off-hours/utils/types/types";
import { cronToString } from "@/store/automations/utils/helpers/cron/cronToString";
import { getCronFrequency } from "@/store/automations/utils/helpers/cron/getCronFrequency";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";

export const getRunDateFromCron = (cron: string | null) => {
  if (!cron) {
    return "";
  }

  const frequency = getCronFrequency(cron);
  const firstLetter = frequency.substring(0, 1).toUpperCase();
  const freq = firstLetter + frequency.substring(1);

  let cronString = cronToString(cron || "");
  if (frequency === "hourly") {
    cronString = cronString.replace("At 0 minutes past the hour,", "");
  }

  return `${freq} - ${cronString}`;
};

export const getAutomationPreviewFormatDate = (date: string) => {
  return formatDate(date, { type: "dateTime" });
};

export const generateAutomationPayloadData = (
  schedule: WorkflowFormData | OffHoursFormData,
) => {
  return {
    body: {
      emails: schedule.emails,
      filter: schedule.filter ?? [],
      name: schedule.name,
      start_date_time: schedule.start_date_time,
      end_date_time: schedule.end_date_time,
      regions: schedule.regions,
      account_id: schedule.account_ids[0],
      time_zone: schedule.time_zone,
      notifications: schedule?.action?.includes("notify")
        ? schedule.notifications
        : null,
      account_ids: schedule.account_ids,
      min_threshold: schedule.min_threshold,
    },
  };
};
